import React from 'react';
import Header from '../components/Header';

const DataUsagePolicy = () => {
  return (
    <>
    <Header />
    <h1 style={{ backgroundColor: "#101010", width: "full", height: "80px", textAlign: 'center', color: "white", padding: '10px' }}>Data Policy</h1>
    <main className="privacy-policy-container" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. How to Delete Your Data</h2>
        <p className="mb-2">If you're a MARQUEL WRECKING USER and wish to delete your data, follow the steps below:</p>

        <p className="mb-4">
          To delete your account and all associated data from the MARQUEL WRECKING database, please:
        </p>

        <ul className="list-disc pl-6 space-y-2">
          <li>
            Send an email to <code className="bg-gray-100 px-1 py-0.5 rounded">e_m@marquelwrecking.org</code> with the subject line: <strong>"DELETE MY ACCOUNT"</strong>.
          </li>
          <li>
            Include the following in your email: your registered email address, phone number, and full name.
          </li>
          <li>
            You will receive a confirmation email once your account has been deleted.
          </li>
          <li>
            Please note: Your data cannot be recovered once deletion is complete.
          </li>
        </ul>
      </section>
    </main>
    </>
  );
};

export default DataUsagePolicy;
